import { createFileRoute } from "@tanstack/react-router";

import { RequirePermission } from "@/hooks/shared/CheckAuth";
import { PayrollAdjustmentsPage } from "@/pages/dashboard/payroll-adjustments/list";

export const Route = createFileRoute("/_main/dashboard/payroll-adjustments/")({
  component: () => (
    <RequirePermission action="payroll.read">
      <PayrollAdjustmentsPage />
    </RequirePermission>
  ),
});
